import { Box, Card, CardContent, Container, Grid } from "@mui/material";
import {
  BrisanjeObrazlozenje,
  BrisanjeRazlog,
  InfoOperater,
  Loading,
  Poruka,
} from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import useSWR from "swr";
import { useContext, useEffect } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { TIP_INFO_PORUKE } from "../../enums";
import { Context } from "../../context";
import { useMojiPodaci } from "../../hooks";

interface FormValues {
  obrazlozenje: string;
  razlogBrisanja: string;
  razloziBrisanja: string[];
  loading: boolean;
  infoPoruka: string;
  tipInfoPoruke: number | null;
}

const defaultValues = {
  obrazlozenje: "",
  razlogBrisanja: "",
  razloziBrisanja: [],
  loading: false,
};

const fetcher = (url: string) => fetch(url).then((res) => res.json());

const Index = () => {
  const methods = useForm<FormValues>({
    defaultValues,
  });
  const [{ token }] = useContext(Context);
  const { operaterPlatforme } = useMojiPodaci(methods);

  const { data: razloziBrisanja } = useSWR(
    `${process.env.REACT_APP_API_URL}/zahtjevi/brisanje/razlozi`,
    fetcher,
    {
      fallbackData: defaultValues.razloziBrisanja,
    }
  );

  useEffect(() => {
    methods.reset((formValues) => ({
      ...formValues,
      razloziBrisanja,
    }));
  }, [razloziBrisanja]);

  const onSubmit = async (data: any) => {
    delete data.razloziBrisanja;

    methods.setValue("loading", true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/zahtjevi/brisanje/operateri`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { status } = response;
      if (status === 200) {
        methods.setValue("infoPoruka", response.data.message);
        methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.SUCCESS);
        methods.resetField("obrazlozenje");
        methods.resetField("razlogBrisanja");
      }
    } catch (error: any) {
      const { status } = error.response;
      if (status === 400) {
        if (error.response.data.errors) {
          error.response.data.errors.forEach((error: any) =>
            methods.setError(error.fieldName, { message: error.error })
          );
        }
        if (error.response.data.message) {
          methods.setValue("infoPoruka", error.response.data.message);
          methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.ERROR);
        }
        return;
      }
      if (error.response.data.message) {
        methods.setValue("infoPoruka", error.response.data.message);
        methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.ERROR);
      }
    } finally {
      methods.setValue("loading", false);
    }
  };

  return (
    <FormProvider {...methods}>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component={"form"}
              onSubmit={(e) => {
                methods.clearErrors();
                methods.handleSubmit(onSubmit)(e);
              }}
            >
              <InfoOperater />
              <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
                <CardContent>
                  <BrisanjeObrazlozenje />
                  <BrisanjeRazlog />
                </CardContent>
              </Card>
              <Grid container justifyContent={"flex-end"} sx={{ mt: 3 }}>
                <Button variant={"contained"} type={"submit"}>
                  Podnesi zahtjev
                </Button>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Loading />
      <Poruka />
    </FormProvider>
  );
};

export default Index;
